import { ApiKey } from "@/types/api-keys";
import { fetchJson } from "@/services/api-client";
import { Product } from "@/types/subscription";

export async function createApiKey(
  organizationId: string,
  userId: string,
  product: Product,
): Promise<ApiKey> {
  const { apiKey } = await fetchJson<{ apiKey: ApiKey }>(
    "/api/api-keys",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        organizationId,
        userId,
        product,
      }),
      cache: "no-store",
    },
    { fallbackErrorMessage: "Failed to create API key" },
  );

  return apiKey;
}

export async function deleteApiKey(
  apiKeyId: string,
  organizationId: string,
): Promise<void> {
  await fetchJson<unknown>(
    "/api/api-keys",
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      cache: "no-store",
      body: JSON.stringify({ apiKeyId, organizationId }),
    },
    { fallbackErrorMessage: "Failed to delete API key" },
  );
}

export async function getApiKeys(
  organizationId: string,
  forceRefresh = false,
): Promise<ApiKey[]> {
  const url = forceRefresh
    ? `/api/api-keys?orgId=${organizationId}&_=${Date.now()}`
    : `/api/api-keys?orgId=${organizationId}`;

  const { apiKeys } = await fetchJson<{ apiKeys: ApiKey[] }>(
    url,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      cache: "no-store",
    },
    { fallbackErrorMessage: "Failed to get API keys" },
  );

  return apiKeys;
}
